import { useState } from "react";

export default function UpdateScoresForm({ game, API, accessToken, onUpdate, onCancel }) {
  const [homeScore, setHomeScore] = useState(game.home_score ?? "");
  const [awayScore, setAwayScore] = useState(game.away_score ?? "");
  const [loading, setLoading] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API}/games/${game.id}`, {
        method: "PUT", // or "PUT" depending on your backend
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          home_score: homeScore === "" ? null : Number(homeScore),
          away_score: awayScore === "" ? null : Number(awayScore),
        }),
      });

      if (!res.ok) throw new Error("Failed to update scores");

      onUpdate(); // refresh games list in parent
      onCancel(); // close the form
    } catch (err) {
      console.error(err);
      alert("Error updating scores");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="flex gap-2 items-center mt-2">
      <input
        type="number"
        min="0"
        placeholder="Home"
        value={homeScore}
        onChange={(e) => setHomeScore(e.target.value)}
        className="border p-1 rounded w-16"
      />
      <span>–</span>
      <input
        type="number"
        min="0"
        placeholder="Away"
        value={awayScore}
        onChange={(e) => setAwayScore(e.target.value)}
        className="border p-1 rounded w-16"
      />
      <button
        type="submit"
        disabled={loading}
        className="bg-green-500 text-black px-2 py-1 rounded text-sm"
      >
        Save
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="bg-gray-300 text-black px-2 py-1 rounded text-sm"
      >
        Cancel
      </button>
    </form>
  );
}
